import ReportTable from './ReportTable.jsx';
export default ReportTable;